import React, { Component } from 'react';

import BasicTemplate from './BasicTemplate.js'


class Greetings extends Component {

  render() {
      return (
          <BasicTemplate>
              <h3><b>Gracias por contactarte con nosotros!.</b></h3>
              <p>Cualquier duda o consulta que tengas podés comunicarte con nuestro Centro de Atención On Line.</p>
              <p>Saludos</p>
          </BasicTemplate>
          );
  };
}

Greetings.contextTypes = {
  intl: React.PropTypes.object.isRequired
}

export default Greetings;


/** WEBPACK FOOTER **
 ** ./src/components/Greetings.js
 **/